'use strict';

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.extend({
    data: function data() {
        return {
            sidebarOpen: false,

            sidebarSection: '',
            sidebarUser: null,
            activeComponent: null
        };
    },

    computed: {
        isDrawn: function isDrawn() {
            return this.sidebarOpen && this.$state.ui.app_width <= 769;
        },
        isClosed: function isClosed() {
            return !this.sidebarOpen;
        },
        isOpen: function isOpen() {
            return this.sidebarOpen && this.$state.ui.app_width > 769;
        }
    },
    created: function created() {
        var _this = this;

        this.listen(this.$state, 'sidebar.component', function (component) {
            _this.activeComponent = component;
        });

        this.$nextTick(function () {
            var sidebarDefault = _this.$state.setting('sidebarDefault');
            if (sidebarDefault && _this.$state.ui.app_width > 769) {
                _this.sidebarSection = sidebarDefault;
                _this.sidebarOpen = true;
            }
        });
    },

    methods: {
        section: function section() {
            if (this.isClosed) {
                return '';
            }

            var section = this.sidebarSection;
            var isChannel = this.$state.getActiveBuffer().isChannel();

            if (section === 'settings' && isChannel) {
                return 'settings';
            } else if (section === 'user' && this.sidebarUser && isChannel) {
                return 'user';
            } else if (section === 'nicklist' && isChannel) {
                return 'nicklist';
            } else if (section === 'about') {
                return 'about';
            }

            return '';
        },
        close: function close() {
            this.sidebarOpen = false;
            this.sidebarSection = '';
            this.sidebarUser = null;
        },
        showUser: function showUser(user) {
            this.activeComponent = null;
            this.sidebarUser = user;
            this.sidebarOpen = true;
            this.sidebarSection = 'user';
        },
        showNicklist: function showNicklist() {
            this.activeComponent = null;
            this.sidebarOpen = true;
            this.sidebarSection = 'nicklist';
        },
        showBufferSettings: function showBufferSettings() {
            this.activeComponent = null;
            this.sidebarOpen = true;
            this.sidebarSection = 'settings';
        },
        showAbout: function showAbout() {
            this.activeComponent = null;
            this.sidebarOpen = true;
            this.sidebarSection = 'about';
        },
        toggleNicklist: function toggleNicklist() {
            this.sidebarSection === 'nicklist' ? this.close() : this.showNicklist();
        },
        toggleBufferSettings: function toggleBufferSettings() {
            this.sidebarSection === 'settings' ? this.close() : this.showBufferSettings();
        },
        toggleAbout: function toggleAbout() {
            this.sidebarSection === 'about' ? this.close() : this.showAbout();
        }
    }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarState"]
window._kiwi_exports.components.SidebarState = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SidebarState.vue
// module id = g1je
// module chunks = 1